module.exports = __webpack_public_path__ + "static/media/9.161a67b5.jpeg";